/* eslint-disable */
const {KitModule, registerModule} = window;

class InteractiveGrid extends KitModule {
  constructor($element) {
    super($element);
    this.detail = this.$element.querySelector('.interactive-grid__detail');
    this.grid = this.$element.querySelector('.interactive-grid__grid');
    this.init();
  }

  get swiper() {
    return this.detail.querySelector('.swiper')?.swiper;
  }

  init() {
    // Single listener for all interactions
    this.$element.addEventListener('click', (e) => {
      const item = e.target.closest('.interactive-grid__item');
      if (item) this.toggle(true, parseInt(item.dataset.index), item);

      if (e.target.closest('.close-btn')) this.toggle(false);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.$element.classList.contains('interactive-grid--active')) {
        this.toggle(false);
      }
    });
  }

  toggle(show, index = 0, item = null) {
    this.$element.classList.toggle('interactive-grid--active', show);
    this.detail.classList.toggle('is-open', show);

    if (show) {
      this.activeItem?.classList.remove('is-active');
      this.activeItem = item;
      item?.classList.add('is-active');

      // Update Swiper
      // A hidden carousel may still be waiting for its lazy runtime. Retain
      // the latest selection so first initialization opens the clicked card.
      const carousel = this.detail.querySelector('.swiper');
      if (carousel) carousel.dataset.initialSlide = String(index);
      if (this.swiper) {
        this.swiper.slideTo(index, 0);
        this.swiper.update();
      }

      // Scroll detail pane to center of screen
      setTimeout(() => {
        this.$element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.detail.setAttribute('tabindex', '-1');
        this.detail.focus({ preventScroll: true });
      }, 100);
    } else {
       this.activeItem?.classList.remove('is-active');
       this.activeItem = null;
    }
  }
}

registerModule('InteractiveGrid', InteractiveGrid);
